export default "__VITE_ASSET__CmT5orSZ__"